import { PasswordPolicy } from "types/PasswordPolicy";
import { PasswordRules } from "components/PasswordSetup/types";
import messages from "./messages";

export const getPasswordPolicyStatements = (
  policies: PasswordPolicy,
  formatMessage: FormatMessage
) => {
  if (
    policies &&
    Object.keys(policies?.age).length === 0 &&
    Object.keys(policies?.complexity).length === 0 &&
    Object.keys(policies?.lockout).length === 0
  ) {
    return [];
  }
  const passwordPolicyStatements: Array<string> = [];

  const passwordRequiredCheck: any = {};

  if (policies.complexity?.minLength && policies.complexity?.minLength > 0) {
    passwordPolicyStatements.push(
      formatMessage(messages.minLength, {
        length: policies.complexity?.minLength,
      })
    );

    passwordRequiredCheck.minLength = policies.complexity?.minLength;
  }
  if (policies.complexity?.minLowerCase) {
    passwordPolicyStatements.push(formatMessage(messages.hasLowerCase));
    passwordRequiredCheck.minLowerCase = true;
  }

  if (policies.complexity?.minUpperCase) {
    passwordPolicyStatements.push(formatMessage(messages.hasUpperCase));

    passwordRequiredCheck.minUpperCase = true;
  }

  if (policies.complexity.minNumber) {
    passwordPolicyStatements.push(formatMessage(messages.hasNumber));

    passwordRequiredCheck.minNumber = true;
  }

  if (policies.complexity.minSymbol) {
    passwordPolicyStatements.push(formatMessage(messages.hasSymbol));

    passwordRequiredCheck.minSymbol = true;
  }

  if (policies.complexity.excludeUsername) {
    passwordPolicyStatements.push(formatMessage(messages.noUsername));

    passwordRequiredCheck.excludeUsername = true;
  }

  if (policies.complexity.dictionary?.common?.exclude) {
    passwordPolicyStatements.push(formatMessage(messages.noCommonPassword));
    passwordRequiredCheck.noCommonPassword = true;
  }

  if (
    Array.isArray(policies.complexity.excludeAttributes) &&
    policies.complexity.excludeAttributes.includes("firstName")
  ) {
    passwordPolicyStatements.push(formatMessage(messages.noFirstName));
    passwordRequiredCheck.firstName = true;
  }

  if (
    Array.isArray(policies.complexity.excludeAttributes) &&
    policies.complexity.excludeAttributes.includes("lastName")
  ) {
    passwordPolicyStatements.push(formatMessage(messages.noLastName));
    passwordRequiredCheck.lastName = true;
  }

  return { passwordPolicyStatements, passwordRequiredCheck } as PasswordRules;
};
